import { ClientTag as GraphQlClientTag } from "@acto/gql/graphql";
import LocalizedStringMap from "./LocalizedStringMap";

export default class ClientTag {
  constructor(
    public readonly key: string,
    public readonly value: string | undefined,
    public readonly name: LocalizedStringMap,
    public readonly description?: LocalizedStringMap,
  ) {}

  static fromGraphql(data: GraphQlClientTag): ClientTag {
    return new ClientTag(
      data.key,
      data.value ?? undefined,
      LocalizedStringMap.fromGraphql(data.name),
      data.description ? LocalizedStringMap.fromGraphql(data.description) : undefined,
    );
  }
}
